export const EMPTY_TEXT_VALUE = '-';
